import axios, { AxiosResponse } from "axios";
import { from, Observable } from "rxjs";

export class BaseEnvidanPortalApiService {
  protected baseUrl = `${process.env.VUE_APP_PORTAL_URL}EnviWCFWebService/`;
  protected config = {
    withCredentials: true
  };    
}
